<template>

<div class="text-image-3 inner">

    <div class="text-image-3-image">

        <div class="text-image-3-image-big" v-bgimage="item.image" />

        <div class="text-image-3-image-small" v-bgimage="item.image_small" />

    </div>

    <div class="text-image-3-text">
    
        <div class="text-image-3-text-text ecc" v-html="item.text" />
    
        <div class="text-image-3-text-subtitle" v-if="item.subtitle">{{ item.subtitle }}</div>

        <div class="text-image-3-text-links" v-if="item.links.length">

            <div v-for="(link, index) in item.links" :key="index" class="text-image-3-text-links-item">

                <a class="text-image-3-text-links-item-title" :href="link.url" v-if="link.url">{{ link.title }}</a>
                <div class="text-image-3-text-links-item-title" v-if="!link.url">{{ link.title }}</div>

                <div class="ecc" v-if="link.text">

                    <p class="text-image-3-text-links-item-text">{{ link.text }}</p>

                </div>

            </div>

        </div>
        
    </div>

</div>

</template>

<script>

export default {

    props: ['item']

}

</script>

<style scoped>

.text-image-3 {
    display: grid;
    grid-template-columns: 600px 1fr;
    grid-gap: 40px;
    padding: 0px 10px;
}

.is-tablet .text-image-3 {
    grid-template-columns: 272px 1fr;
    grid-gap: 30px;
}

.is-mobile .text-image-3 {
    grid-template-columns: 1fr;
    grid-gap: 30px;
    margin: 20px 0px;
}

.text-image-3-text {
    padding-top: 40px;
}

.is-tablet .text-image-3-text {
    padding-top: 20px;
}

.is-mobile .text-image-3-text {
    padding-top: 0px;
}

.text-image-3-image {
    height: 560px;
    background-repeat: no-repeat;
    background-size: 285px 388px;
    background-position: 0px 0px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoQAAANVCAMAAADWfB9DAAAAPFBMVEUAAADzx4/yyJHyyZHvz4/yyJHvx4/0yo/yyJHyyJLyyJHyyY/zyJHyyJHxyJLxyJHyyJHyyJLxyJHyyJEFpUUpAAAAE3RSTlMAQIDAEPAgMOBgoFCQsHDP0K9vgO/r5gAAGQ1JREFUeNrs2YGKgkAUhtGx1MqCsPv+77pELJEbKbWOE57zDB+D9zcBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPCgOiZYTn3omoguwTJ2l23c9HWC7I6nfdydVUhe9aFv4lGzS5BLeznHE43zhAwGBQ4dEgxkKfDOkcxA3gIdyQzlLdCRzFDeAh3JDGUvcKipEmQq0JHMH2UUqEL+TX0t8F2nBJ+quhhjMGRG9WUfn+pMNbzv2McIgyFzajf7iFAhkxX6CP5WaLZmrkfQzxNuyn4EVcjyj6DZmuUfQRUyWXtqYlabBK9UfUzg5wmzqbbxhArJ5rCPEWZr5lS/SlCFzK/eNDHKzxMefNdBbLbmtbaLCVTIoy/bZFTI8puMCll+k1Ehy28yzzWWmjW7bjIFsBeuVyEJqnDFiklQhWtVwLegCtetKitBFa5PtY3yqHBN2j6KpMLV+GHvbnAbhYEoAA9gA4aQspn733V3qVpFjvmrGntmeN8JKuUJ4+cxdQNLhRReg5xWBim8qofkCCKFVyCslUlpCCyrPlgB3H4yTGQrgxReSSt3S4wUXoPgVgYpvAjpW2Kk0Dwd+xF8p8Ywd2ON8M0uQ4K2lfgL/gWZFa2WWgaXn6xyNSvW4wDPAHljqzhGvhipM4Mn/CFQTV01iLrQGo3VYMqdQCml1SDqQkPUVoMoaqxQXA0ihTborgZR1FigvRpM+SBQxNCGBEWNUp3Bx+DiRqCEiLfBKbjR8wJFzeV0AurpKbjlT/H820YC+cqf0jWfCXxKIYqaS3ENl+VvLT1pZ/6Gj1pfw+i5qGmkiJt5gbrwItzAJfV1u/1sxudB7CvbT08jrfhOIS7gmVdzOfFDML0i4+qTcfmLmfghmDGFviWQ58H5xQ/B/RTiFNmwMkNb8UNwP4U4RbarVDHT3x1FtlOI8zur3B8uohkpsp9CnJzYVKiYmSqKHEshOmuDHlzC0FLkcApxF9majEtxfDxcPoW4BSpCiXLQ146IRKQQr4UCFNgV98HRzznPCwzUmHHj3PpAPxPNF2KUwYj8k4NNRUSyUog7Jz+g+C7T0smISyGm/U/S/IGPpZMRmEKMMpQz8L7yncxmCtFZ6+Y+OKfBEZHYFGKU4SDJP2KGhTjWMWOUQbcHbxO3I34VGJ21Zm7gfPqK3uPO/+Hj/jq1H7xJVDW9u7PCKINGledcfE3vNPE/uH6nUM37io8pHB9mwGuhPrtzW6K3xOlhBlx80iVfOzhtRlBk04QFeZO6w+KmojwqLMjK7Dw35LcyCQE9jSrB8xotrczqRgtTXToEzuLQllhqXYgP1LzSN0PdtJTdjAVZiYEz8IFOkFgXYp4mpm2O/+aoiNYzY8xauiz14FzRKTK3/bh990xZPejvVNDIjEkG0VafE+oOSNYFLMiijZ5TtLbTKwbGvSe5Aq/RWw2mTLgOL1bNabqrwQTXMzO+kiTRwAn6q8GUzmNBlmh1elB9NZgSMFooULoetFENpgwYLRSnW8mg2Z/KzRgtFObd9WAv74dqPRZkURIZNPs2+G00+5RX6c0Z9ELPFWqMFsrx5gxOEh+DiwYLshQvGTTaDb5yHpW1DC8ZtHhEsqLDUJcIcQZtFzOxO6asBQie32eWV8zEJuxNigv8wngxE3Ez9iYnacqggLnBIzqPvckpmjIot5iJBOxNTpH6ENDTT6fcsDc5QU8GZRczsRl7k8P0ZFDZZ1p+a5ShJ5CSQU1L8afqIq2oNFEGr1UOvrhh1P8INRlUsyt+5npchj9C5FuQmbasw97kIPn3SbzaH6HG3mSbmgzOit+JZuxNNmnJ4KDxdfBLh73JX/bOBUlVIIai4Sv+UMv97/UVzjBvEBChHL0k5yyBSiedm9vhnVyud/D3y4aU3mQKxQe3HYoVKjNdMnqTMVYSg9maS3ErGdCbjKPoGVn3oG6Ymt5kmFXEoPJjpjlk9CZjCA5J5dcrLC3I9CaD6A/rVjmoG2ZPb9JjFTHoyst5ZH3rAPIita9reF6QCv+UnxhEoR5nTyrsoy0Qrs+/OsmBX0t0UBTBnE1J+uQVinUHcYFwjR7qaRKuKb8Rb4zPfqSZDgdS4Q+CTZ9XefC+IJMKW8TFGVfyYJc9Cxn+o+wg9CUP3pHxhRr0LjmRik1JKmzQboy9uGZGSUmFZtqNsUd5sEtekQrlvqdP59YD9vRucpfsCPLgH9hpcLd+cSAGF1EWpEKpshIwBs1SUqFqUxImBs0qjP6ak5JAMWgJ7lbJSUmkGDQ74m5VudaEjUErC1KhRj2JG4NmKalQzb4VLgbNKlKhlkodMAYtIRV+vpYEj0GzI6lQYOdj7Bh8SW9ytKjkFTGoUk/Cjk0uxKBMbxJ1glwTgzq9SVBf4YYYVBIZQlqs8xMxKJUKLSA7YlArFXp/kjPAnhgUS4Xx1jF8j+v4N4xQYQm3pOvCu7obSq+Qo83uWnWGNXtKqTDWYS4L9iyYyaXCWIJ108vxh5wbUk8WI92ta/ZutWj1eoEO9CuL8dmgJWV29zwnBMIWtVQYZnaXIhB+IfhlowjWGwTCDlr+zCBSQ4ZA2ENnyePJIlAjEPYRcrdGeGxSFgiEHdRSYYTZ3QWB8B6xVOi/19sjEA6hZOlyf7jzAoFwAK2+z/uXPSAQ9lFLhc77vQRxZhipW6FzleZEYzyMVoPsusqkNCXvoOCIT7gu+RXWAGJn3fPjz5tEyIrlYaQkCL837oRfdz5G57WJ3xVdt66NfY4jaN17vN536utrqLx+IKVUWJtLvi8qPEscQevm49Tb2h5OzugYUrM7l0d9c21gq+1DhHwiLl0MGbaFKaS6QI9S4ZY3JQ/R++D+XAx5hZ9/Gqk+0N+9J8VLPYHeJ/fmYsgLLoTvJmcu1eXAhfA5lDQxZ1JhiUI4jd5X92UT2TEynoHMH+9c3cCbI8lvr55FZ3bnyrWZ4d/6DGcEsZYEQ/8chARrRw+eMrwzM5BSxtzcgBKK8SyUOkI3X72iGM9AKwF4qcdbivEstDKAk3pcUYznIjRA9jEf2FKM56Ik0foYEFQU4wXoTE086NUJe2fmolWJPOjVGU88FyGzl8aBtTVh58cShKRCB09NMorxIoReOa5+K01CMf485+B+roxi/Hnq2P7qDU5WAfLY+tgOJ6sCx8h38pI3nv/YO7PjgEEghgaw8YHBnkn/vaaI/Oh6LbADrCQWCIZziOHJWGAMTt/DaNsTXMDg8Q0xrMgzIHTf3vDM5BkUPtcQw4g8A8Pluhe06NQwdNMQQ89MViA+zxDDHZ0aiGUZYtj2pGeA6JaWwYpODcXpeB6f0amheAxDDOU3n7lAcRiaJnd0ajB2O6Fii06Nxm13KbyiU6Mx7C6FbzZCONwuhcdvPh6HY5ophU9aYzwusxXZ0xrjsXl5qFc2QkSa1b4wY5Ygspyc/B7XGJLu9OZuJT6DyWeU8X+TI8Tk8VHNet67g3L4nE8rGyEqp42J9caxQ+V/IYYfHvLJLi6Xy8KsbISwdBf19o1jh8vusT30OHbATI9g68pGCMzyCLa+ceyAOSyCrT2OHTS7w2un5T2kG57mcCmcaUugqQ5eVoKE2BSDDEOJbQyOwR7x5G9tcJp+Z/JGJASnyqere34ZR2fIB2mujAdGZ5O/s8+cxvB86mmu3W7yEx+PeHtc8rYEn0t8iWoi1fh08Uhhi2VHwKndHidAw8CUbo9LAjQMVOkrU41lx8CQbo+nRWyXnkO6Pd7lxXgNlNvjI70xB59we7yiVHOg3B7P+MYcKLfHZ66EHAi3xz0CDQnC7fGIXcKCbntsNIuWHd32uCXYz8KUXalcCWmQbY+NhnLTM1Tt1ZU8Kw2HqkZjM5NbAVWN5tXt+/X4NNdqM5hxosPULMKSUDURVfPqVPPgmIihWYQz4z+IKJrH1qkqPWkiKaf1qIRUSCY/9QeOafEpShk1xjEVTdFibTGOqZAUCvO8hIsqWIRHpGouquDg6it9CRdFcL3upBe4UCzCN+kFLjbBIswbJzb07vAlz97Z0DO4ViYhsfHJFWEiNHQ0uSI805ew0dRWbEuEho6pVoSJ0PBR1YowERo+qtqjz6b6jFUYuQTDnmg/HUOsCHsiNHwUsSJMhIYQtSJ8EqHhQ60IE+0nRK0IE6EhRKwI/9g7A+MGgSCIzeOACR5w/926DumkFnwJ+/diSaEhslzKyVMLDRHXYTK1H4lrCFNokKiGMIWGiWoIV58vQaIawi21H4lqCO8UGiSqIUyhYWIawtoxoZiGMLUfiulnS6GBYhrCFBoopiGsHROKaAhrx6QiGsL/FBoooiFMoYHyFg1h7ZhQlugJltoPRaT3p9BQEQ1hCg0V0RDWjklF1EWT2k/F08qVQoPF00+YQoPFM4S1Y2K5NENYOyYWT3H6nkJDRfMJiRQaLpoTZe2YXDRDmNqP5U8zhCk0WDzfO06hwaIZwtoxuTwW8aR2TC4af+FKocFyWYYwhYaL5cKkdkwwu2QIU/vBWO5bU2i4LMtDLIWGy8cyhLVjctkkSSq1H8wluTBJoQHzksT5FBowu+S3qx2Ty2G5Zqgdk8uSnCnfKTRcNsmZMoUGzC35B1I7JphTsthI7QcjuXBNoQGzJE+xFBowj+QpVjsmmEuyoakdE8xXEqVOyR/TSCRRKoUGzJJEqdoxwWySKJXaD+aWHI5TaMCckiiVQsPlkKgntWOC+UjUkz4wC2aTXNql0IB5Sc4lKTRgLG33tWNyseT52jHBWF7VfST3PiOxvKqbQgPGkudrxwQjyfOp/WAseT6FBowlz6fQgLHk+doxwVjyfO2YXCx53rJyH4nlVV3Lyn0kljxvWbmPxJLnU/vBWPK8ZOU+kkOS5y0r95FY8nztmGAseb4PzIKx5HnLyn0kkjxvWbmPxJLnLSv3kVjyfO2YYCyv6t6SlftILGq/ZeU+EUuerx0TjCXPp/aDseR5y8p9JJY8b1m5j8SS52vH5GLJ86n9YH7s3UENADAMw8Dn+DMejp5jFJbVZYrPK8k9iXLaryT3JIrPK8k9ieLzyClQEsXnleSeRFm7V5J7EsXnlTWdJIrP74PZwyA+ryT3JIrPK8k9ieLzSnJPovi8sqaTRHmqq3xIVUQ57VeSexLF55U1nSSKz++0/zCKzyvJPYni80hyT6L4vLKmk0TxeeVDqiSKzyvJPYly2q8k9ySIzyvJPYni88opUBLlqa6S3JMoa/dKck+i+LyyplNE8XnlQ6okis8ryT2J4vNKck+i+LyS3JMoPq+s6RRRnuo+JLknUU77leSeRPF5ZU0nieLzO+0/DOLzSnJPovi8ktyTKD6vrOkkUXxe+ZAqieLzSnIvovi8ktyTKD6vJPckis8rp0BJlKe6SnJPoqzdI8k9ieLzyppOEsXnlQ+pkig+ryT3JIrPK8k9ieLzyJpOEsXnlTWdJMpTXSW5J1FO+5XknkTxeWVNJwni88opUBLF55XknkRZu1eSexLF55U1nSSKzysfUhVRfF5J7kkUn1eSexLF55XknkTxeeUUKInyVBdJ7kmUtXsluSdRfF5Z00mi+LzyIVUSxeeV5J4E8XkluSdRfF5Z00mi+LyS3JMoT3WV5J5EOe1XknsRxeeVNZ0kis8rp0BJlKe6SnJPoqzdK8k9ieLzyppOEcXnlQ+pkig+ryT3JIrPK8k9ieLzSnJPovg8cgqURHmqqyT3JMravZLckyg+r6zpJFF8XvmQKgni80pyT6L4vJLckyg+v9P+wyg+ryT3JIrPK8m9iOLzSnJPovi8sqbz2buDG4BhGIaBQB/df+SuUR/FKQjCUZIoPq+cAiVRnuoqyT2JsnaPJPckis8razpJFJ9XPqRKovi8ktyTKD6/dczDID6vrOkkUXxeOQVKojzVVZJ7EmXtXknuSRSfV9Z0iig+r3xIlUTxeSW5J1F8XknuSRSf32n/YRSfR5J7EsXnleSeRPF5JbknUXxeWdNJovi8cgqUBHmqqyT3JMravZLckyg+r6zpJFF8XvmQKoni80pyL6L4vLKmk0TxeWVNJ4ni8w+itkmUp7pKck+ydcxfJfckis8razpJFJ9XPqRKopz2K8k9ieLzSnJPovj8Tvvvovi8ktyTKD6vJPckis8ryT2J4vPKmk4SxOeVU6AkylNdJbknUdbuleSeRPF5ZU0nieLzyodURRSfV5J7EsXnlTWdJIrPK2s6SRSfV5J7EsXnkeSeRPF5JbknUXxeWdNJovi88iFVEuW0X0nuSRCfV5J7EsXnd9p/GMXnleSeRPF5JbknUXx+65h3UXxeWdNJovi8cgqURHmqqyT3JMravZLckyg+r6zpFFF8XvmQKoni80pyT6L4vLKmk0Tx+Z32HwbxeSW5J1F8XknuSRSfV5J7EsXnlTWdJIrPKx9SJUFO+5XknkTxeSW5J1F8fqf9h1F8XknuSRSfR5J7EsXnlTWdJIrPK2s6SRSfV06BkihPdZXknmTrmL9K7kkUn1fWdJIoPq98SJVE8XkluSdRfF5Z00mC+PxO+w+j+LyS3JMoPq8k9ySKzyvJPYni88qaThHF518kuSdRTvuV5J5E8fmPvXPBaR2KYiAkJM2ntMDd/16pEBJCUECkFJ+xZwdP6HGNz9SlVO6WUPJ81P7CUPI8pHK3hJLnKZW7JZQ8T1nTsYSS5ylfSGUJJc9TVCBLIB/VpVTulmQdU6tyt4SS5ylrOpZkHVOrcreEkucplbsjlDxPWdOxhJLno/YXhpLnKZW7JZQ8T6ncLaHkeUjlbgklz1PWdCyh5PkZUrlbQlH7KZW7JZQ8T6ncLaHk+aj9daHkeUrlbgklz1Mqd0soeZ6ypmMJJc9TvpDKEkiep1TullDyPKVyt4SS5ymVuyWUPE9Z07Ek65halbsjFLWfUrlbQsnzlDUdSyh5Pmp/YSh5nlK5W0LJ85DK3RJKns86ZmEoeZ6ypmMJJc9nHbMwFLWfUrlbAsnzlMrdEkqe3/bvGPpu1dGB7KDk+a5tZnrs8hvxpyTPn4222zkus07t5AIlzw/tgvT7VSdo8KHk+bFdmuH0OCcmfoVIntf5Ic3tTzguTzr/0bBEofnJ4zzncf6ASp4XUmj69rcMfR7nd8jkeaGP6rZrMD3mcX5FJ8/r/ER27Woc9+lwTkTt31i5b6fv0uFo5HmKQpMDy6/QyPNCCs0GtX9zh5PHOeuYv63cc2ARIV8wmw7n34lCc1mmHFiyjilBnw7H8qO6UxMjkqyd2j82SXJgcVJo1qZLJNmsY2qQA0vWMSWIJMteu29lyIElCo0GkWSBCs3c6pEDC0ztX1pR0uFEodHAXJKFKDSF/i45x2Db4WQdUwtLSTbrmIK4HVgoar+UQhNJNgoNB5MDC0ShuWtc8JIsZR1TWaHJgeUbDlFo6kCVZKPQVAN4YMk6ZklQHU7WMQtDObBEoSnOBOhwKArNvjlTXJLNOiaGugeWrGOiKCnJjlFoeFQ7sEShoVJIkqUoNGXV/g8YHlgoaj9ToTGRZCEKzc3a9WYnE86BhaLQvLCb9ylqCnY4lHXMN24PS57mWpIsZR3zPXe33X0e5zJf1UdR+z9hXPM4l5BkKQrNWXaH5aEF6QMLZR3za06Pc2KiriRLWcf8njEdjuqB5Zm9O8htGwiCKMoAToIscv/rJiNoZ9OiaJlT0/3+JQROPbT+FiE0x99w/DjHIdkqhOa5Nxw/zkkDS5XrmCfecPw4pyDZKrT/XL8MLAkDSxVC84V+eMM59YaD0NwysDxoESRb5Trmi95w/Dg/8Vd9rmN+V7//+HE+hmQzaH8koTGw7JY6sNQkNC/pzcDyGMkiNLtBsp8XNrBUof0fBsl+Ug6S7UFoDCx7RQwsfQgNJHtFA8m2vY55JEj2iu4DS8frmFf35g3n8RsO2r+TgeXCBpJFaPaDZC/p/ld9La5jng2SvaaBZMtfx0zIwHJyYPmJ0PwPkr2ugWQRmv0g2Uu6DyzlrmMGBskeQLJo/14GlusaAwtCsxcku0ZdCA0kG1zENaeVcoXkw9D+IxlYYmtKaCDZpHyXQLLT605oDCwBdaL974NkE0Jotg2SfUEITVaQbI/rmPkZWBCajCBZhCYiSBahycgVkhbXMRfIwIL2RwTJIjQZQbIITUYGFt8lGRlYEJqIuiNZhCalxkgWoYmq5cDS7zpmfu2QLNofWicki9Ak1+QKie+S9BoMLJtWqDSSRfsXqiqSRWhWq+DAgtCsWDEki/YvWxkki9AsXgUki9AUaPWBBaGp0sJI1nXMUq2JZNH+eq32hoPQFG2lgQWhqdwiSNZ3SfnykSxC06LsgWVTm1KRLELTrUAk6zpmx8KQLNrftpyBBaHpXQSS3aRTAwtCo1GRNxy0X9MHFoRG05EsQqNzSBbt127rDSwIjaYjWYRG0/+qD6HRdCTrOqbODixov54vFMkiNJo+sCA0mv6G47tE0weWTXoZkkVoNL2BZBEazW8MLK5jan5jYEFoNL3bX/UhNJreQLK+SzS/MbAgNJreDcmi/ZreGFgQGs1vvOEgNJrebWBB+/9tFAw4AI3hjC6hGQWjgBAAAAw21U0p1OM6AAAAAElFTkSuQmCC');
}

.is-tablet .text-image-3-image {
    height: 260px;
    background-size: 118px 161px;
}

.is-mobile .text-image-3-image {
    background-size: 118px 161px;
    height: 220px;
    width: 300px;
    margin: 0px auto;
}

.text-image-3-image-big {
    position: absolute;
    left: 104px;
    top: 80px;
    width: 400px;
    height: 400px;
    transform: rotate(-7deg);
    background-size: cover;
    background-position: 50% 50%;
    border: 10px solid #fff;
    z-index: 2;
}

.is-tablet .text-image-3-image-big {
    width: 180px;
    height: 180px;
    left: 48px;
    top: 30px;
}

.is-mobile .text-image-3-image-big {
    width: 180px;
    height: 180px;
    left: 48px;
    top: 30px;
}

.text-image-3-image-small {
    position: absolute;
    right: 0px;
    bottom: 0px;
    width: 240px;
    height: 240px;
    background-size: cover;
    background-position: 50% 50%;
    z-index: 1;
}

.is-tablet .text-image-3-image-small {
    width: 100px;
    height: 100px;
    right: 0px;
    bottom: 0px;
}

.is-mobile .text-image-3-image-small {
    width: 100px;
    height: 100px;
    right: 0px;
    top: 60px;
}

.text-image-3-text-subtitle {
    color: #45464B;
    font-size: 16px;
    font-weight: 500;
    font-family: "Montserrat", sans-serif;
    text-transform: uppercase;
    margin-top: 50px;
}

.is-tablet .text-image-3-text-subtitle {
    font-size: 14px;
    margin-top: 40px;
}

.is-mobile .text-image-3-text-subtitle {
    font-size: 13px;
    margin-top: 30px;
}

.text-image-3-text-links {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 10px;
    margin-top: 30px;
}

.is-mobile .text-image-3-text-links {
    margin-top: 20px;
}

.text-image-3-text-links-item {
    border-bottom: 1px solid #EAF1EB;
}

.text-image-3-text-links-item:last-child {
    border-bottom: 0px;
}

.text-image-3-text-links-item-title {
    color: #45464B;
    font-size: 16px;
    font-weight: 700;
    font-family: "Montserrat", sans-serif;
    line-height: 50px;
    display: block;
    padding: 0px 10px 0px 60px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAABLCAMAAADXnC7SAAAAPFBMVEUAAABMpHRKpXRKpHRLpXRQn3BLpXRKpXVKpXVLpXNLpXRLpnRLpHRIp3hLpnRNpnNKpXVLpXRMpXNLpXS9sYU3AAAAE3RSTlMAP8CX8BCAYDDgz6BwINBQr7Bvd7grGAAAAU1JREFUSMftltuSxBAQQBEEMbn5/39dOkWvEDJ52IetnJcZ+jStpSohNcbVObMLco9RO4DLOxlUuwTfe7ZYQZQfcexiaHtxHqRZHXXBQDYWH46y8zETV7qB8IcgSocF1LXOx9PkhgkVfS4jtp7wCYebaqWOkFBbfcJxL2FCvZ5gRF4k6K2ElSAU9AbhIiwWr31nBGkx+yOki5E4QMr2sfjfb7b8jq0MWNXphGPqzZb3CoAFEeacPqr3EZVFqr6KG9gUQF96cDrfQKfqMRB+zv4CdcBpScNHuN8X0tg9f4OZAbLaPl4TRMeej08NROk3Pu/5CPjuoa9oxETf0MTZX1wGRDNs7k+lz7MZlvssCw7Q7o5PyTX/0Ue0ja8xhHX7jzr6j++XCJqYoz/jnPj2+Xz913/913/9v/d3ipTfA0j0S8AveOTLoUQG3w4VyA8csEfYt9vbqwAAAABJRU5ErkJggg==');
    background-position: 20px 50%;
    background-repeat: no-repeat;
    background-size: 23px auto;
}

.is-tablet .text-image-3-text-links-item-title {
    font-size: 14px;
}

.is-mobile .text-image-3-text-links-item-title {
    font-size: 13px;
    background-size: 18px auto;
    padding: 0px 10px 0px 54px;
}

.text-image-3-text-links-item-title:hover {
    border-color: #00583D;
}

.text-image-3-text-links-item-text {
    margin-left: 60px;
}

.is-desktop .text-image-3-text-links-item-text {
    padding-bottom: 20px;
}

.is-mobile .text-image-3-text-links-item-text {
    margin-left: 54px;
}

</style>
